import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Col } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import CareTeamMemberCard from '../../components/Person/CareTeamMemberCard';
import { loadCareTeam } from '../../redux/modules/care-team/care-team-middleware';
import { messages } from './Careteam.i18n';
import LoadingIndicatorContainer from '../LoadingIndicatorContainer';
import { callWithLoadingIndicator } from '../../redux/modules/loading-indicator/loading-indicator-middleware';

class Careteam extends React.Component {
  UNSAFE_componentWillMount() {
    const {
      patientId,
    } = this.props;

    if (patientId) {
      this.props.dispatch(callWithLoadingIndicator('Careteam', () => this.props.dispatch(loadCareTeam(patientId))));
    }
  }

  getSortedCareteam() {
    return this.props.careTeam.sort((x, y) => {
      if (x.lastName.toLowerCase() < y.lastName.toLowerCase()) return -1;
      if (x.lastName.toLowerCase() > y.lastName.toLowerCase()) return 1;
      if (x.firstName.toLowerCase() < y.firstName.toLowerCase()) return -1;
      if (x.firstName.toLowerCase() > y.firstName.toLowerCase()) return 1;
      return 0;
    });
  }

  renderCareTeamMember(member) {
    return (
    <Col key={member.careProviderId}>
      <CareTeamMemberCard dispatch={this.props.dispatch}
        careTeamMember={ member }
        windowSize={this.props.windowSize}
      />
    </Col>);
  }

  render() {
    return (
      <div>
        <LoadingIndicatorContainer loadingKey="Careteam" >
          <div className="row pt-3 mb-1">
            <div className="col">
              <h2 tabIndex="0"><FormattedMessage {...messages.careteam} /></h2>
            </div>
          </div>
          <div className="row row-cols-1 row-cols-md-3 g-4 mb-3 small">
            { this.props.careTeam.length > 0 ? this.getSortedCareteam().map((member) =>
              (this.renderCareTeamMember(member))) :
              <div className="col appointment-container">
                <div className="fs-1">
                  <span className="fa-regular fa-calendar"></span>
                </div>
                <span><FormattedMessage {...messages.noCareteam} /></span>
              </div>}
          </div>
        </LoadingIndicatorContainer>
      </div>
    );
  }
}

Careteam.propTypes = {
  dispatch: PropTypes.func,
  careTeam: PropTypes.array,
  windowSize: PropTypes.string,
  patientId: PropTypes.string,
};

const mapStateProps = (state) => ({
  patientId: state.profile.patient.patientId,
  careTeam: state.careTeam.members,
  windowSize: state.window.size,
});

export default connect(mapStateProps)(Careteam);